import { isProduction } from './env'
import devCompanyData from './data/dev.json'
import productionCompanyData from './data/production.json'

const configManager = () =>
  isProduction ? productionCompanyData : devCompanyData

export default configManager
